export default "__VITE_ASSET__CTIb1iUT__"